export function getUrlParams(search: string): Map<string, string> {
  try {
    if (search.indexOf('?') < 0) {
      return new Map();
    }
    if (!search.startsWith('?')) {
      search = search.substr(search.indexOf('?'));
    }
    const paramsArray = search.substr(1).split('&');
    let key;
    let value;
    const result: Map<string, string> = new Map();
    for (const item of paramsArray) {
      const result2 = item.split('=');
      key = result2[0];
      value = decodeURIComponent(result2[1]);
      result.set(key, value);
    }
    return result;
  } catch (error) {
    console.log('获取url参数失败', error);
    return new Map();
  }
}

export function getQuery(name: string) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  const r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return null;
}

export function getUrlLast(url: string) {
  const paramsArray = url.split('/');
  return paramsArray.pop();
}

export function transUrl(url: string) {
  if (url.indexOf('/') === 0) {
    if (url.indexOf('//') === 0) {
      return window.location.protocol + url;
    } else {
      return window.location.origin + url;
    }
  } else {
    if (url.indexOf('://') !== -1) {
      return url;
    } else {
      return window.location.origin + window.location.pathname + url;
    }
  }
}
